// extracted by mini-css-extract-plugin
module.exports = {"content":"Minting_content__Jz_ym","contentButton":"Minting_contentButton__2soL0"};